export default __webpack_public_path__ + "static/media/jack.46e10e95.svg";